import { render, staticRenderFns } from "./TabAvaliacaoAtendimento.vue?vue&type=template&id=6b717893&scoped=true"
import script from "./TabAvaliacaoAtendimento.vue?vue&type=script&lang=js"
export * from "./TabAvaliacaoAtendimento.vue?vue&type=script&lang=js"
import style0 from "./TabAvaliacaoAtendimento.vue?vue&type=style&index=0&id=6b717893&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b717893",
  null
  
)

export default component.exports